import { useState } from "react";

const FIXED_LOGO_URL =
  "https://i.ibb.co/VYjFzZ0g/Logo-Transp-Ray-Melo.png";

const socials = [
  { icon: "ri-instagram-line", label: "Instagram", href: "#" },
  { icon: "ri-tiktok-line", label: "TikTok", href: "#" },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;

    try {
      const body = new URLSearchParams();
      body.append("email", email);
      if (name) body.append("name", name);

      await fetch("https://readdy.ai/api/form/d6ujpctt4s7j0tv5i52g", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });

      setSubmitted(true);
    } catch {
      setSubmitted(true);
    }
  };

  return (
    <footer className="bg-[#1A1A1A] text-white">
      {/* Newsletter */}
      <div className="border-b border-white/10 px-6 md:px-10 py-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
              <p className="text-[11px] tracking-[0.3em] font-semibold text-white uppercase mb-1">
                Receba Nossas Novidades
              </p>
              <p className="text-[12px] text-white/50">
                Cadastre-se e receba lançamentos e promoções exclusivas
              </p>
            </div>

            {submitted ? (
              <p className="text-sm tracking-widest text-white/60">
                Obrigada por se inscrever!
              </p>
            ) : (
              <form
                onSubmit={handleSubmit}
                className="flex flex-col sm:flex-row gap-2 w-full md:w-auto"
              >
                <input
                  type="text"
                  name="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Seu nome"
                  className="h-11 px-4 bg-white/10 border border-white/20 text-[12px] text-white placeholder:text-white/30 outline-none focus:border-white/50 transition-colors w-full sm:w-44"
                />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Seu e-mail"
                  required
                  className="h-11 px-4 bg-white/10 border border-white/20 text-[12px] text-white placeholder:text-white/30 outline-none focus:border-white/50 transition-colors w-full sm:w-56"
                />
                <button
                  type="submit"
                  className="h-11 px-6 bg-white text-black text-[11px] tracking-[0.15em] uppercase font-medium hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Enviar
                </button>
              </form>
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="px-6 md:px-10 py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10">

          {/* Logo */}
          <div>
            <img
              src={FIXED_LOGO_URL}
              alt="Ray Melo Boutique"
              className="h-16 md:h-20 w-auto object-contain mb-6"
            />
            <p className="text-[12px] text-white/50 leading-relaxed mb-5 max-w-md">
              Moda feminina com modelagem exclusiva e qualidade premium para lojistas que desejam renovar seu estoque.
            </p>

            <div className="flex items-center gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  className="w-9 h-9 flex items-center justify-center border border-white/20 text-white/60 hover:text-white hover:border-white/50 transition-colors"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Atendimento */}
          <div>
            <p className="text-[10px] tracking-[0.25em] font-semibold text-white uppercase mb-5">
              Atendimento
            </p>
            <div className="space-y-3">
              <a
                href="https://wa.me/5511923169450"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2.5 text-[12px] text-white/50 hover:text-white transition-colors"
              >
                <i className="ri-whatsapp-line text-sm" />
                (11) 92316-9450
              </a>
              <p className="text-[12px] text-white/50 leading-relaxed">
                Seg a Sex: 9h às 18h<br />
                Sábado: 9h às 13h
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-white/10 px-6 md:px-10 py-5">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-white/30">
            © {new Date().getFullYear()} Ray Melo Boutique. Todos os direitos reservados.
          </p>
          <p className="text-[11px] text-white/30">
            Desenvolvido por{" "}
            <a
              href="https://www.serraconsultoria.com"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-white/60 transition-colors"
            >
              Serra Consultoria
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}